/**
 * report-frame.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { formatISO } from 'date-fns';
import FeatureBox from 'components/feature-box';
import usePrevious from 'utils/use-previous';


const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    overflow: 'hidden',
    display: props => props.doRun ? 'block' : 'none',
    // handle ios 13 height 100% bug
    '& > *:first-child': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column'
    }
  }
}));


// REQUIRED PARAMS FOR SINGLE
//    reportSourceType
//    recordGroup
//    reportType
//    recordIds
// REQUIRED PARAMS FOR MULTIPLE: all
export default function ReportFrame(props) {
  const {
    doRun,
    reportSourceType,
    recordSetType,
    params,
  } = props;
  const classes = useStyles({ doRun });
  const prevParams = usePrevious(params);
  const paramsUpdated = Boolean(prevParams && JSON.stringify(params) !== JSON.stringify(prevParams)); 
  const [isReportLoading, setIsReportLoading] = React.useState(false);


  React.useEffect(() => {
    if (doRun && params.reportType && (params.recordIds || params.recordGroups)) {
      setIsReportLoading(true);

      // create anonymous form to POST to iframe
      (function() {
        const form = document.createElement('form');
        form.className = 'report-frame-class-name';
        form.action = `${process.env.REACT_APP_HOST}/Report/GeneratePT2Report`
        form.target = 'report-frame';
        form.method = 'POST';

        createFormInput(form, 'export', false);
        createFormInput(form, 'localDateTime', formatISO(new Date()));

        for (let [key, value] of Object.entries(params)) {
          if (value.constructor === Array) {
            for (let i = 0; i < value.length; i++) {
              createFormInput(form, key, value[i]);
            }
          } else {
            createFormInput(form, key, value);
          }
        }

        document.body.appendChild(form);
        form.submit();
      })();
    } else {
      // remove added form 
      const addedForm = document.getElementsByClassName('report-frame-class-name');
      if (addedForm.length > 0) {
        addedForm[0].remove();
      }
    }
  // using paramsUpdated instead of params to avoid re-running effect based on object identity alone
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    doRun, 
    reportSourceType,
    recordSetType,
    paramsUpdated,
  ]);


  const createFormInput = (form, name, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }


  return (
    <>
      <FeatureBox 
        className={`flex-fh ${classes.root}`}
        loading={isReportLoading}
      >
        {doRun &&
        <iframe
          name='report-frame'
          title="Report"
          className='flex-fh'
          style={{ border: 0, width: '100%', height: '100%' }}
          onLoad={() => setIsReportLoading(false)}
        />}
      </FeatureBox>
    </>
  )
}